<template>
    <form
        ref="add_price_list_to_client_form"
        :id="formId"
        @submit.prevent="onSubmit"
    >
        <div class="form row m-b-sm">
            <div class="col-md-3">
                <label>{{ __("price_list_type") }}*</label>
                <select
                    class="form-control"
                    name="priceListTyoe"
                    v-model="priceListType"
                    @change="priceListTypeChange($event.target.value)"
                >
                    <option value="standard">{{
                        __("price_list_type_standard")
                    }}</option>
                    <option value="special">{{
                        __("price_list_type_special")
                    }}</option>
                </select>
            </div>

            <div class="col-md-3">
                <label>{{ __("country_or_name") }}*</label>
                <select
                    class="form-control"
                    :class="priceListErrors.length > 0 ? 'is-invalid ' : ''"
                    name="countryOrName"
                    v-model="priceListSelect"
                    @select="$v.priceListSelected.id.$touch()"
                    @blur="$v.priceListSelected.id.$touch()"
                >
                    <option
                        v-for="option in currentCountryOrNameSelect"
                        :key="option.id"
                        :value="option"
                        >{{ option.countryOrName }}
                    </option>
                </select>
                <span
                    class="help-block text-danger"
                    v-for="error in priceListErrors"
                    >{{ error }}</span
                >
            </div>

            <div class="col-md-3">
                <label>{{ __("currency") }}</label>
                <input
                    type="text"
                    class="form-control"
                    disabled=""
                    :value="currentCurrency"
                />
            </div>

            <div class="col-md-3">
                <label>{{ __("status") }}</label>
                <input
                    type="text"
                    class="form-control"
                    disabled=""
                    :value="__(currentStatus)"
                />
            </div>
        </div>
    </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
    name: "add-price-list-to-client-form",
    data() {
        return {
            priceListType: "standard",
            priceListSelected: {
                currency: {
                    iso_code: ""
                },
                status: ""
            }
        };
    },
    validations: {
        priceListSelected: {
            id: {
                required
            }
        }
    },
    props: {
        formId: String,
        mode: String
    },
    computed: {
        currentCountryOrNameSelect: function() {
            return this.priceListType == "standard"
                ? this.filteredCountriesSelect
                : this.filteredNamesSelect;
        },
        filteredCountriesSelect: function() {
            return this.countriesSelect.filter(current => {
                return (
                    this.priceLists.filter(other => {
                        return other.id == current.id;
                    }).length == 0
                );
            });
        },
        filteredNamesSelect: function() {
            return this.namesSelect.filter(current => {
                return (
                    this.priceLists.filter(other => {
                        return other.id == current.id;
                    }).length == 0
                );
            });
        },
        currentCurrency: function() {
            return this.priceListSelected
                ? this.priceListSelected.currency.iso_code
                : "";
        },
        currentStatus: function() {
            return this.priceListSelected.status !== "" ? (this.priceListSelected.status === 'active' ? 'valid' : 'pending') : '';
        },
        priceListErrors: function() {
            const errors = [];
            if (!this.$v.priceListSelected.id.$dirty) {
                return errors;
            }
            !this.$v.priceListSelected.id.required &&
                errors.push(this.__("field_country_name_is_required"));

            return errors;
        },
        priceListSelect: {
            set: function(value) {
                this.priceListSelected = { ...value };
            },
            get: function() {
                return this.priceListSelected;
            }
        },
        ...mapGetters({
            countriesSelect: "getCountriesSelectPriceList",
            namesSelect: "getNameSelect",
            priceLists: "getPriceLists"
        })
    },
    methods: {
        onSubmit() {
            this.$v.priceListSelected.$touch();
            if (!this.$v.$invalid) {
                if (this.mode == "edit") {
                    this.saveClientPriceLists(this.priceListSelected);
                } else {
                    this.setClientPriceLists(this.priceListSelected);
                }
                this.$emit("closeModal");
            }
        },
        priceListTypeChange(value) {
            Object.assign(this.priceListSelect, {
                currency: {
                    iso_code: ""
                },
                status: ""
            });
        },
        ...mapActions([
            "getCurrencyNameSelect",
            "setClientPriceLists",
            "saveClientPriceLists"
        ])
    },
    mounted() {
        this.getCurrencyNameSelect();
    }
};
</script>
